var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#010101;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M19,9c-0.5,0-0.9,0.4-0.9,0.9c0,2.2-1.8,4-4,4H5.7l2.4-2.4c0.4-0.4,0.4-1,0-1.3s-1-0.4-1.3,0l-4,4 c-0.4,0.4-0.4,1,0,1.3l4,4c0.2,0.2,0.4,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.3l-2.5-2.4H14c3.3,0,5.9-2.7,5.9-5.9 C19.9,9.4,19.5,9,19,9z M6,5.9h8.3l-2.4,2.4c-0.4,0.4-0.4,1,0,1.3C12,9.9,12.2,10,12.5,10c0.2,0,0.5-0.1,0.7-0.3l4-4 c0.4-0.4,0.4-1,0-1.3l-4-4c-0.4-0.4-1-0.4-1.3,0s-0.4,1,0,1.3L14.3,4H6C2.7,4,0,6.7,0,9.9c0,0.5,0.4,1,0.9,1s0.9-0.4,0.9-0.9 C1.9,7.7,3.7,5.9,6,5.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.19fba339.svg";
export { ForwardRef as ReactComponent };